// 可排序的表格欄位標題。點一下切換 asc→desc→清除。
// 用法：<SortableTh field="name" sort={sort} onSort={toggleSort} style={{width:160}}>名稱</SortableTh>
function SortableTh({ field, sort, onSort, children, style, ...rest }) {
  const [f, d] = (sort || '').split(',');
  const active = f === field;
  const arrow = active ? (d === 'desc' ? '▼' : '▲') : '↕';
  return (
    <th
      {...rest}
      onClick={() => onSort(field)}
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap', ...style }}
      aria-sort={active ? (d === 'desc' ? 'descending' : 'ascending') : 'none'}
    >
      {children}{' '}
      <span style={{ opacity: active ? 0.9 : 0.3, fontSize: 11 }}>{arrow}</span>
    </th>
  );
}

export default SortableTh;
